import IComponentController = angular.IComponentController;
import * as UsStates from "../../../core/constants/stateAbbreviations/stateAbbreviations.constant";

export interface IAddressInputBindings {
    onBackBinding: () => any;
    onNextBinding: () => any;
    addressLineOneModelBinding: string;
    addressLineTwoModelBinding: string;
    cityModelBinding: string;
    stateModelBinding: string;
    zipModelBinding: string;
}

interface IAddressInputComponentController extends IAddressInputBindings {
    goNext(): void;
    goBack(): void;
}

export class AddressInputComponentController implements IAddressInputComponentController, IComponentController {
    public addressLineOneModelBinding: string;
    public addressLineTwoModelBinding: string;
    public cityModelBinding: string;
    public stateModelBinding: string;
    public zipModelBinding: string;
    public onBackBinding: () => any;
    public onNextBinding: () => any;

    public static $inject = ["$scope", "ValidationService", "stateAbbreviations"];

    constructor(protected $scope: any,
                protected validationService: any,
                private stateAbbreviations: UsStates.IUsStateInfo[]) { }

    // $onInit is part of the angular component lifecycle and is the recommended hook for running controller initialization logic
    public $onInit(): void {
        // this $scope / validationOptions setup is here so that the validation service works correctly even though we create this form over and over with the same name
        // https://github.com/ghiscoding/angular-validation/wiki/Isolated-Scope
        this.validationService = new this.validationService();
        this.validationService.setGlobalOptions({isolatedScope: this.$scope, controllerAs: this, debounce: 1, hideErrorUnderInputs: true});
    }

    public goNext(): void {
        if (this.validationService.checkFormValidity(this.$scope.quoteWizardForm) === false) {
            return;
        }

        if (this.onNextBinding) {
            this.onNextBinding();
        }
    }

    public goBack(): void {
        if (this.onBackBinding)
            this.onBackBinding();
    }
}
